import { Metamodel } from '../base/model';
import { format, getConnectorV2Name } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';
import { ServiceNowV2LinkedService } from '../linkedservice/servicenow-v2.linkedservice';
import { ServiceNowObjectDataset } from './servicenow.dataset';
import { IAttribute } from '../base/annotation';
@Metamodel.model({
    name: ModelConstants.serviceNowV2Dataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate,
            getConnectorV2Name(shellStringResources.ServiceNow_DisplayText, isTridentInIframe())),
        format(shellStringResources.ModelName_DatasetsTemplate,
            getConnectorV2Name(shellStringResources.ServiceNow_DisplayText, isTridentInIframe()))
    ],
    constraints: {
        linkedService: {
            model: ServiceNowV2LinkedService.MODEL // Linked service redefined
        }
    }
})
export class ServiceNowV2ObjectDataset extends ServiceNowObjectDataset {
    public static readonly VALUE_TYPE: IAttribute;
    @Metamodel.attribute({
        display: shellStringResources.ValueType,
        association: 'VALUE_TYPE'
        })
    public valueType?: string;
}
